// External modules
import React from 'react';
import { func } from 'prop-types';

// Internal modules
import { LazyKYCFields } from './Components';
import { LazyPasswordInput } from './PasswordInput';
import { LegalDisclosures } from './LegalDisclosures';
import { passwordContainerStyleOverrides } from './styles';

const SignupFields = props => (
  <>
    <LazyPasswordInput
      containerStyleOverrides={passwordContainerStyleOverrides}
      {...props}
    />

    <LazyKYCFields {...props} />

    <LegalDisclosures changeHandler={props.changeHandler} />
  </>
);

SignupFields.propTypes = {
  blurHandler: func,
  changeHandler: func,
  focusHandler: func,
};

export { SignupFields };
